import React, { useState } from 'react';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { pageConfigs } from '../../../configs/pageConfigs';
import { TwoFactorSendCodeComponent } from '../../../components/TwoFactorSendCodeComponent/TwoFactorSendCodeComponent';
import { OtpChannel } from '../../../_types/otp.types';
import { useOtpContext } from '../../../context/OtpContextProvider';
import { useOtpLogic } from '../../../hooks/useOtpLogic';
import TurnstileCaptcha from 'components/TurnstileCaptcha';
import {
  FactorValidationWrapper,
  SubtitleOtpRequest
} from '../ForgotPasswordOtpRequest/ForgotPasswordOtpRequest.styles';
import { useSchema } from '../../../hooks/useSchema';

export const OtpRequest: React.FC = () => {
  const {data: pageConfig = {}} = useGetTemplate(pageConfigs.otpRequest.template);
  const {selectedChannel, setSelectedChannel} = useOtpContext();
  const {
    displayUserData,
    isLoading,
    handleOtpRequest,
    determineSecurityCodeQuestion
  } = useOtpLogic();

  const {otpRequestChannelType} = useSchema()

  const [optionsCount, setOptionsCount] = useState<number>(0);
  const [captchaToken, setCaptchaToken] = useState<string>('');
  const [captchaKey, setCaptchaKey] = useState(0);

  const handleChannelSelect = (channel: OtpChannel) => {
    setSelectedChannel(channel);
  };

  const handleUpdateOptionsCount = (count: number) => {
    setOptionsCount(count);
  };

  const handleSubmit = async () => {
    await handleOtpRequest(captchaToken);
  };

  const handleVerify = (token: string) => {
    setCaptchaToken(token);
  };

  const handleError = () => {
    setCaptchaToken('');
    setCaptchaKey(prev => prev + 1);
  };
  
  return (
    <PageContainer
      title={pageConfig.title}
      navigateBack={pageConfigs.otpRequest.navigateBack()}
      buttonText={pageConfigs.otpRequest.buttonLabel}
      onClick={handleSubmit}
      loading={isLoading}
      disabled={isLoading || !captchaToken || !selectedChannel}
      extraAboveButton={<HelpBox/>}
      thereIsButton
    >
      <SubtitleOtpRequest>
        {determineSecurityCodeQuestion(optionsCount)}
      </SubtitleOtpRequest>

      {displayUserData && (
        <FactorValidationWrapper>
          <TwoFactorSendCodeComponent
            otpRequestChannelType={otpRequestChannelType}
            userData={{
              phoneNumber: displayUserData.phoneNumber,
              email: displayUserData.email
            }}
            onChannelSelect={handleChannelSelect}
            selectedChannel={selectedChannel}
            updateOptionsCount={handleUpdateOptionsCount}
          />
        </FactorValidationWrapper>
      )}

      <TurnstileCaptcha onVerify={handleVerify} key={captchaKey} />
    </PageContainer>
  );
};
